/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { FileStlCap } from './capabilities/FileStlCap';
import { GenericSolidCap } from './capabilities/GenericSolidCap';
import { FloorCap } from './capabilities/FloorCap';
import { ActorCap } from './capabilities/ActorCap';
import { Text3DCap } from './capabilities/Text3DCap';
import { LightCap } from './capabilities/LightCap';
import { AxisHelperCap } from './capabilities/AxisHelperCap';
import { SkyboxCap } from './capabilities/SkyboxCap';
import { FileObjCap } from './capabilities/FileObjCap';
/**
 * Initializers for all basic caps.
 * Convinience to avoid having to add each Capability separately.
 */
export class DefaultCaps {
    static init(director) {
        director.addCapability(new FileStlCap());
        director.addCapability(new FileObjCap());
        director.addCapability(new SkyboxCap());
        director.addCapability(new AxisHelperCap());
        director.addCapability(new LightCap());
        director.addCapability(new Text3DCap());
        director.addCapability(new ActorCap());
        director.addCapability(new GenericSolidCap());
        director.addCapability(new FloorCap());
    }
}
//# sourceMappingURL=DefaultCaps.js.map